((Header, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.searchOpen = $('.js-search-open');
    $dom.searchClose = $('.js-search-close');
    $dom.mobileSearchOpen = $('.js-mobile-search-open');
    $dom.mobileMenu = $('.js-mobile-menu');
    $dom.mobileMenuToggle = $('.js-mobile-menu-toggle');
    $dom.menuTabSwitch = $('.js-menu-tab-switch');
    $dom.menuTab = $('.js-menu-tab');
    $dom.submenu = $('.js-submenu');
    $dom.submenuOpen = $('.js-submenu-open');
    $dom.submenuReturn = $('.js-submenu-return');
    $dom.floatButton = $('.js-menu-float-button');
  };

  const getMenu = ($trigger, $menu) => {
    const target = $trigger.data('target');
    return $menu.filter('[data-menu="' + target + '"]');
  };

  const openSearch = (event) => {
    const $self = $(event.currentTarget);
    const $parent = $self.closest('.js-search-form');

    if ($parent.hasClass('is-active')) {
      $parent.submit();
    } else {
      $parent.addClass('is-active');
      $parent.find('input.search-field').select();
    }
  };

  const openMobileSearch = (event) => {
    const $self = $(event.currentTarget);
    const $parent = $self.closest('.js-mobile-menu-container');
    const $search = $parent.find('.js-search-form');
    $search.addClass('is-active');
    $parent.find('input.search-field').select();
  };

  const closeSearch = (event) => {
    const $self = $(event.currentTarget);
    const $parent = $self.closest('.js-search-form');

    $parent.removeClass('is-active');
  }

  const setMobileTop = () => {
    let windowHeight = $(window).innerHeight();
    let mobileNav = $('.nav-header__mobile-menu');
    let bannerHeight = $('.banner-is-shown').innerHeight();
    let emailPushdown = $('.email-pushdown.is-active').innerHeight();
    let navHeaderHeight = $('.main-header-wrapper').outerHeight(true); // set to include padding + margin because it has some wonky code
    let searchFormMobileHeight = $('.nav-header__search-form--mobile').innerHeight();
    let heightFromTop = bannerHeight + emailPushdown + navHeaderHeight + searchFormMobileHeight;
   
    let navHeight = windowHeight - heightFromTop;

    mobileNav.attr('style', `height: ${navHeight}px !important`);
    $dom.mobileMenu.animate({top:heightFromTop},200)
  }

  const toggleMobileMenu = () => {

    if(window.collectionFiltersActive) return;

    $dom.mobileMenuToggle.toggleClass('is-active'); 
    $dom.mobileMenu.toggleClass('is-active');
    
    if ($dom.mobileMenu.hasClass('is-active')) {
      Scroll.lock();
      $('[data-close-email-pushdown]').trigger('click');
      $dom.floatButton.addClass("is-active");
      $('#gorgias-web-messenger-container').addClass('move');
      setMobileTop();
    } else {
      Scroll.unlock();
      $dom.floatButton.removeClass("is-active");
      $('#gorgias-web-messenger-container').removeClass('move');
    }
  };

  const switchTab = (event) => {
    const $self = $(event.currentTarget);
    
    if ($self.hasClass('is-active')) {
      return;
    }

    const $menu = getMenu($self, $dom.menuTab);
    $dom.menuTabSwitch.removeClass('is-active');
    $dom.menuTab.removeClass('is-active');
    $self.addClass('is-active');
    $menu.addClass('is-active');
  };

  const openSubmenu = (event) => {
    const $self = $(event.currentTarget);
    const $menu = getMenu($self, $dom.submenu);
    $dom.submenu.removeClass('is-active');
    $menu.addClass('is-active');
    $dom.floatButton.addClass('is-submenu');
  };

  const closeSubmenu = (event) => {
    const $self = $(event.currentTarget);
    $self.closest('.js-submenu').removeClass('is-active');
    $dom.floatButton.removeClass('is-submenu');
  };

  const handleMenuState = () => {
    const $activeSubmenu = $dom.submenu.filter('.is-active');

    if ($activeSubmenu.length) {
      $dom.submenu.removeClass('is-active');
      $dom.floatButton.removeClass('is-submenu');
      return;
    }

    toggleMobileMenu();
  }

  const bindUIActions = () => {
    $dom.searchOpen.on('click', openSearch);
    $dom.searchClose.on('click', closeSearch);
    $dom.mobileSearchOpen.on('click', openMobileSearch);
    $dom.mobileMenuToggle.on('click', toggleMobileMenu);
    $dom.menuTabSwitch.on('click', switchTab);
    $dom.submenuOpen.on('click', openSubmenu);
    $dom.submenuReturn.on('click', closeSubmenu);
    $dom.floatButton.on('click', handleMenuState);
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  }

  Header.init = init;

})(window.Header = window.Header || {}, jQuery);